import { Paper, Skeleton, Typography } from '@mui/material'
import React from 'react'
import BodyHeader from '../molecules/BodyHeader'
import Figures from '../molecules/Figures'

import strips from '../../media/strips.svg'
import chairSun from '../../media/chair-sun.svg'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'

import instaSrc from '../../media/insta_button_icon.svg'

import useArtCraft from '../../hooks/useArtCraft'
import useFigures from '../../hooks/useFigures'
import { CATEGORIES, SERVICES } from '../../constants'
import useDefaultLeftRight from '../../hooks/useDefaultLeftRight'

import chairIcon from '../../media/chair_green_icon.svg'
const ArtCraft = () => {
	const { isLoading, title, content } = useArtCraft()
	const { figures } = useFigures(CATEGORIES.FIGURES.ARTISANAT.id)
	const { data: artisanats } = useDefaultLeftRight(SERVICES.ARTISANAT)

	return (
		<>
			{(isLoading && <Skeleton />) || (
				<>
					{artisanats && (
						<BodyHeader title={title} list={artisanats}>
							{content}
						</BodyHeader>
					)}
				</>
			)}

			{artisanats &&
				artisanats.map(({ id, type, slug, title, content }, index) => (
					<Zone color={(index % 2 === 0 && 'white') || 'ivory'} key={id} id={slug}>
						<TitleSubtitle title={type} subtitle={title} />
						<Typography
							sx={(theme) => ({
								color: 'text.primary',
								textAlign: 'left',
								fontSize: 18,
								mt: 4,
								display: 'flex',
								width: '100%',
								flexFlow: (index % 2 === 1 && 'row-reverse wrap') || 'row wrap',
								fontFamily: 'montserrat',
								justifyContent: 'space-between',

								px: 2,

								[theme.breakpoints.down('md')]: {
									mt: 2,
								},

								'& figure': {
									pt: 4,
									m: 0,
									display: 'flex',
									justifyContent: (index % 2 === 0 && 'flex-start') || 'flex-end',
									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										pt: 0,
										flexBasis: '100%',
									},

									'& img': {
										display: 'block',
										overflow: 'hidden',
										borderRadius: '8px',
										height: 'auto!important',
										width: '100%!important',

										[theme.breakpoints.down('md')]: {
											width: '100%',
										},
									},
								},
								'& em': {
									fontSize: 16,
								},

								'& a': {
									color: 'secondary.main',
									fontWeight: 'bold',
								},

								'& h2': {
									fontSize: 22,
									fontWeight: 800,
									color: 'text.primary',
									mb: 2,
									background: (theme) => `url(${chairIcon}) no-repeat ${theme.spacing(0, 1)}`,
									pl: 4.5,
									display: 'table',
									[theme.breakpoints.down('md')]: {
										fontSize: 19,
										backgroundPositionY: 6,
										backgroundSize: 15,
										pl: 3,
										fontWeight: 900,
									},
								},
								'& pre': {
									borderLeft: `4px solid ${theme.palette.secondary.main}`,
									fontWeight: 700,
									fontFamily: 'montserrat',
									[theme.breakpoints.up('md')]: {
										p: theme.spacing(0, 0, 0, 2),
									},
									'& .MuiTypography-root': {
										[theme.breakpoints.down('md')]: {
											fontSize: 16,
										},
									},
								},
								'& blockquote': {
									m: 0,
									my: 2,
									fontSize: 22,
									'& p': {
										fontWeight: 'bold',
										mb: 0,
									},

									'& cite': {
										fontSize: 16,
										fontWeight: 400,
										position: 'relative',
										fontStyle: 'normal',
										textAlign: 'right',
										display: 'block',
									},
								},

								'& .wp-block-group': {
									flexBasis: '47%',

									[theme.breakpoints.down('md')]: {
										flexBasis: '100%',
									},
								},

								'& .wp-block-buttons': {
									display: 'flex',
									justifyContent: 'space-around',

									'& .wp-block-button:nth-of-type(2) a': {
										backgroundColor: 'white',
										color: 'secondary.main',
										textDecoration: 'none',

										background: `white url(${instaSrc}) no-repeat bottom 8px right 15px`,
										pr: 6,
									},
								},

								'& .wp-block-button__link': {
									fontFamily: 'museomoderno',
									cursor: 'pointer',
									position: 'relative',
									display: 'inline-block',
									borderRadius: '28px',
									fontSize: 16,
									p: theme.spacing(1, 2),
									bgcolor: 'secondary.main',
									color: 'white',
									fontWeight: 700,
									my: theme.spacing(2),
									minWidth: 169,
									border: `3px solid ${theme.palette.secondary.main}`,
									textDecoration: 'none',

									'&:hover': {
										bgcolor: 'secondary.main',
										border: `3px solid ${theme.palette.secondary.main}`,
									},

									[theme.breakpoints.down('md')]: {
										display: 'flex',
										m: theme.spacing(0, 'auto'),
										mt: 1,

										'& a': {
											display: 'flex',
											p: 3,
											border: 'none',
										},
									},
								},
							})}
							component="div"
							dangerouslySetInnerHTML={{ __html: content }}
						/>
					</Zone>
				))}

			<Paper
				sx={(theme) => ({
					bgcolor: 'primary.main',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(16, 14),
					backgroundImage: `url(${strips})`,
					backgroundRepeat: 'round no-repeat',

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
						backgroundRepeat: 'no-repeat',
					},
				})}
			>
				<img src={chairSun} alt="Le cycle du réemploi solidaire" />
				<Typography
					sx={(theme) => ({
						fontWeight: 800,
						fontSize: 22,
						px: 20,
						mt: 2,
						lineHeight: 1.2,
						[theme.breakpoints.down('md')]: {
							px: 0,
							my: 2,
						},
					})}
				>
					Artisanat et réemploi, des savoir-faire au service de l’écologie
				</Typography>
				<Typography
					sx={(theme) => ({
						fontWeight: 400,
						fontSize: 18,
						mt: 1,
						px: 10,
						[theme.breakpoints.down('md')]: {
							px: 0,
							my: 2,
						},
					})}
				>
					Selon l’Ademe, 2,8 millions de tonnes d'éléments mobiliers ont été mis sur le marché
					français en 2018, soit l'équivalent de 281 millions d'unités. <br />
					La qualité intrinsèque des matériaux et des techniques de fabrication déterminent la
					réparabilité des mobiliers et la viabilité économique des opérations de restaurations.
					Plus le mobilier sera moderne et issu des grandes enseignes d'ameublement à bas coût,
					moins il sera techniquement possible et économiquement viable de le restaurer.
				</Typography>
			</Paper>

			<Zone color="black">
				<TitleSubtitle
					subtitle="La Collecterie en chiffres"
					title="depuis 2012"
					color="white"
					inverseTitle
				/>
				{figures && <Figures list={figures} />}
			</Zone>
		</>
	)
}

export default ArtCraft
